import React from 'react'
import './navbars.css'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faSearch,faGlobe,faUser,faHome,faChevronDown,faBus,faHelicopter,faMap,faHotel, faPhone,faCar,faBriefcase,faImage,faXmark, faNavicon, faUserCircle} from '@fortawesome/free-solid-svg-icons'
import { useRef } from 'react';
import { useState } from 'react';
import { Link } from 'react-router-dom';   
const tourData = {
  one: [
    {
      title: "4 Hour Everest Heli Tour:",
      desc: "Mt.Everest is the tallest mountain in the world.",
      img: "/img/mounteve/Heli.webp",
      src:"/Everest-Heli-Tour",
    },
    {
      title: "The Big Four:",
      desc: "Discover ancient art, culture, and temples.",
      img: "/img/capital/swyambhunathdslr.jpeg",
      src:"/One-Day-kathmandu-Tour",
    },
     {
      title: "7 Unesco Heritage:",
      desc: "We will discover 7 Unesco heritage site in One days.",
      img: "/img/capital/pasupatinath.jpg",
      src:"/one-day-nepal-7unescoheritage-tour",
    },
  ],

  short: [
    {
      title: "Heritage & Horizone",
      desc: "Peaceful lakes and mountain views await you 6 Days Tour.",
      img: "/img/pokhara/pokhara3dslr.jpeg",
      src:"/kathmandu-pokhara-6days-tours",
    },
    {
      title: "Peak & Safaris:",
      desc: "Visiting Kathmandu Chitwan and Nagarkot in 6 Days Tour.",
      img: "/img/chitwan/chitwan4dslr.webp",
      src:"/kathmandu-chitwan-nagarkot",
    },
    {
      title: "The Quick & Classic:",
      desc: "Exploring Culture Sprituality and Natural Beauty in just 4 days.",
      img: "/img/capital/nagarkot.webp",
      src:"/kathmandu-nagarkot-4days-tour",
    },
  ],

  medium: [
    {
      title: "Nepal's Golden Triangle:",
      desc: "Place we are visiting Kathmandu-Chitwan-Pokhara 8 Days Tour.",
      img: "/img/chitwan/chitwandslr.webp",
      src:"/kathmandu-chitwan-pokhara-8days-nepaltour",
    },
    {
      title: "The Classic Circuit",
      desc: "Visiting Kathmandu-Chitwan-Pokhara-Bandipur-Nagarkot in 9 Days.",
      img: "/img/pokhara/bandipur.jpg",
      src:"/kathmandu-chitwan-pokhara-bandipur-nagarkot-9days-tour",
    },
    {
      title: "Nepal Essential Four",
      desc: "Visiting Kathmandu-Chitwan-lumbini-Pokhara in 8 Days.",
      img: "/img/chitwan/lumbini.jpg",
      src:"/kathmandu-chitwan-lumbini-pokhara-8days-tour",
    },
    
  ],

  long: [
    {
      title: "Bhuddhism Tour",
      desc: "we are going to visit different buddhist place in 13 days.",
      img: "/img/capital/namobuddha.webp",
      src:"/buddhism-tour-nepal",
    },
    {
      title: "All Nepal Tour",
      desc: "we are visiting all popular places of nepal in just 15 Days ",
      img: "/img/company/airportdslr.jpeg",
      src:"/all-nepal-tour",
    },
    {
      title: "Nature's Majestic Loop",
      desc: "Visiting Kathmandu-Chitwan-Lumbini-Pokhara-Ghandrkh-Dampush-Bandupur-Nagarkot in 10 days.",
      img: "/img/treek/Dhampus.webp",
      src:"/kathmandu-chitwan-lumbini-pokhara-ghandrukh-dhampush-bandipur-nagarkot-10daystour",
    },
  ],
}
const NewNavbar = () => {
  const[comany,setCompany]=useState(false);
  const comdrop = () => {
    setCompany(!comany);
  };
  const[bcomany,bsetCompany]=useState(false);
  const bcomdrop = () => {
    bsetCompany(!bcomany);
  };
  const [activeTour, setActiveTour] = useState("one");
  let alerting=()=>{
    alert("Comming Soon !");
  }
  const [toogl, setToogl] = useState(false);
  const openMenu = () => {
    setToogl(!toogl);
  };
  const Close = () => {
    setToogl(!toogl);
  };
  const [toogle, setToogle] = useState(false);
  const all=()=>{
     setToogle(!toogle);
  }
  const searchef= useRef(null);
const openSearch = () => {
  searchef.current.classList.add("topnav-search-active");
};
const closeSearch = () => {
  searchef.current.classList.remove("topnav-search-active");
};
  return (
    <header>
      <div className="topnav">
       <Link to="/Home"> <div className="left">
          <div className="image-nav">
            <img src="/img/company/himalayaslogo.png" alt="logo" className='logo'/>
          </div>
        </div></Link>
        <div className="center">
        <div className="topnav-search-item">
              <p className='topnav-p'>Where:</p>
              <input placeholder="Where are you going?" />
        </div>
        <div className="topnav-search-item">
              <p className='topnav-p'>Date:</p>
              <input type="date "placeholder="For which date" />
        </div>
        <div className="topnav-search-item">
              <p className='topnav-p'>Number:</p>
              <input type="number" placeholder="No of Travellers" />
        </div>
        <div className="topnav-button">
            <FontAwesomeIcon icon={faSearch} className='button-search'/>
        </div>
        </div>
        <div className="topnav-right">
        <div className="topnav-host desktop"onClick={()=>alerting()}>Become a host</div>
          <div className="topnav-icon" onClick={()=>all()}><FontAwesomeIcon icon={faGlobe}/>
          <div  className={toogle?'popup':'language'}>
            <div className="language-head">
            <div className="upp"><p className="lang">Language</p></div>
            <div className="cross"onClick={()=>all()}>Close</div>
            </div>
            <div className="inner">
            <a href="#">Chinese Language</a></div>
          </div>
          </div>
          <div className="topnav-icon mobile"onClick={()=>openSearch()}><FontAwesomeIcon icon={faSearch}/></div> 
          <div className="topnav-icon mobile"onClick={openMenu}><FontAwesomeIcon icon={faNavicon}/>
          </div>
          <div id="topnav-menu" className={toogl?'topnav-menu-active':''}>
        <div className="topnav-menu-header"onClick={Close}>
        <div><FontAwesomeIcon icon={faXmark}/></div>
        </div>
       <Link to="/Home" onClick={Close}><div className="topnav-menu-item">Home</div></Link>

       <Link to="/nepal-tour"onClick={Close}>  <div className="topnav-menu-item">
          Nepal Tour
        </div></Link>

        <Link to="/hotel" onClick={Close}><div className="topnav-menu-item">Hotel</div></Link>
        <Link to="/guidetable" onClick={Close}>  <div className="topnav-menu-item">Hire Guide</div></Link>
       <Link to="/rental" onClick={Close}><div className="topnav-menu-item">Car</div></Link>
        <Link to="/activity" onClick={Close}> <div className="topnav-menu-item">Activity</div></Link>
        <Link to="/contactus" onClick={Close}> <div className="topnav-menu-item">Contact Us</div></Link>
        <div className="topnav-menu-item" onClick={()=>comdrop()}>
          Company <FontAwesomeIcon icon={faChevronDown}/></div>
          <div className={comany?'topnav-dropdown':'topnav-notdropdown'}>
            <Link to="/aboutus"className='answ' onClick={Close}>About Us</Link>
            <Link to="/whytravel"className='answ' onClick={Close}>Why Travel With Us</Link>
            <Link to="/meetourfounder"className='answ' onClick={Close}>Meet Our Founder</Link>
            <Link to="/legal"className='answ' onClick={Close}>Legal Documents</Link>
            <Link to="/b2b"className='answ' onClick={Close}>We Work For You (B2B)</Link>
             <Link to="/reviews"className='answ' onClick={Close}>Reviews</Link>
          </div>
        

        <div className="topnav-menu-item" onClick={()=>bcomdrop()}>
          Resource <FontAwesomeIcon icon={faChevronDown}/> </div>
            <div className={bcomany?'topnav-dropdown':'topnav-notdropdown'}>
            <Link to="/gallery"className='answ' onClick={Close}>Gallery</Link>
            <Link to="/Terms"className='answ' onClick={Close}>Terms & Condition</Link>
            <Link to="/faqs"className='answ'onClick={Close}>FAQs</Link>
        </div>
      </div>
          <div className="topnav-icon desktop"onClick={()=>alerting()}><FontAwesomeIcon icon={faUserCircle}/></div>
          
          <div ref={searchef} className="topnav-search-popup">
        <div className="topnav-search-header">
          <div onClick={closeSearch}><FontAwesomeIcon icon={faXmark}/></div>
        </div>
        <div className="topnav-search-content">
          <input placeholder="Where are you going?" />
          <input placeholder="Check in" />
          <input placeholder="Check out" />
          <input placeholder="Guests" />
          <button className="footer-newsletter-button">Submit</button>
        </div>
      </div>

        </div>
      </div>
      <nav className='nav-mobile'>
      <ul className='mobile-nav'>
        <li>
            <Link to="/nepal-tour">
             <div className="icon-nav"><FontAwesomeIcon icon={faBus} className='color' /></div> 
              <p className='p-nav'>Nepal Tour <FontAwesomeIcon icon={faChevronDown}/></p>
            </Link>
          </li>
          <li>
          <Link to="/rental">
             <div className="icon-nav"> <FontAwesomeIcon icon={faCar} className='color' /></div>
              <p className='p-nav'>Rental</p>
            </Link>
          </li>
          <li>
            <Link to="/activity">
            <div className="icon-nav">  <FontAwesomeIcon icon={faHelicopter} className='color' /></div>
              <p className='p-nav'>Activities</p>
            </Link>
          </li>
          <li>
            <Link to="/guidetable">
             <div className="icon-nav"> <FontAwesomeIcon icon={faMap} className='color' /></div>
              <p className='p-nav'>Hire Guide</p>
            </Link>
          </li>
          <li>
            <Link to="/hotel">
             <div className="icon-nav"> <FontAwesomeIcon icon={faHotel} className='color' /></div>
              <p className='p-nav'>Hotel</p>
            </Link>
          </li>
          
        </ul>
      </nav>
      <nav className='nav-desktop'>
     
        <ul className="desktop-nav">
        <li>
            <Link to="/Home">
              <FontAwesomeIcon icon={faHome} />
              <p className='p-nav'>Home</p>
            </Link>
          </li>
          <li className='nepal-tour a'>
          <FontAwesomeIcon icon={faBus} />
              <p className='p-nav'>Nepal Tour<FontAwesomeIcon icon={faChevronDown}/></p>
            <div className="tour-wrapper">
      <div className="tour-list">
        <ul>
          <li
            className={activeTour === "one" ? "active" : ""}
            onClick={() => setActiveTour("one")}
          >
            One Day Tour
          </li>
          <li
            className={activeTour === "short" ? "active" : ""}
            onClick={() => setActiveTour("short")}
          >
            Short Day Tour
          </li>
          <li
            className={activeTour === "medium" ? "active" : ""}
            onClick={() => setActiveTour("medium")}
          >
            Medium Day Tour
          </li>
          <li
            className={activeTour === "long" ? "active" : ""}
            onClick={() => setActiveTour("long")}
          >
            Long Day Tour
          </li>
        </ul>
      </div>
              <div className="tour-content">
              <div className="finishing-h3"><h3>Popular Packages</h3></div>
        <div className="card-container">
        
          {tourData[activeTour].map((item, index) => (
            <div className="package-card" key={index}>
             
              <img src={item.img} alt={item.title} />

              <div className="card-body">
                <h3>{item.title}</h3>
                <p>{item.desc}</p>
                <Link to={item.src} className="learn-more">
                  Learn More →
                </Link>
              </div>
            </div>
          ))}
        </div>

       <Link to="/nepal-tour"><div className="auto"> <button className="view-all">View All Package</button></div></Link>
      </div>
      </div>
          </li>
          <li>
            <Link to="/hotel">
            <FontAwesomeIcon icon={faHotel} />
              <p className='p-nav'>Hotel</p>
            </Link>
          </li>
          <li>
            <Link to="/guidetable">
              <FontAwesomeIcon icon={faMap} />
              <p className='p-nav'>Hire Guide</p>
            </Link>
          </li>
          <li>
            <Link to="/rental">
              <FontAwesomeIcon icon={faCar} />
              <p className='p-nav'>Car</p>
            </Link>
          </li>
          <li>
            <Link to="/activity">
              <FontAwesomeIcon icon={faHelicopter} />
              <p className='p-nav'>Activity</p>
            </Link>
          </li>
          <li>
            <Link to="/contactus">
              <FontAwesomeIcon icon={faPhone} />
              <p className='p-nav'>Contact Us</p>
            </Link>
          </li>
          <li className='a companyMenu'>
              <FontAwesomeIcon icon={faBriefcase} />
              <p className='p-nav'>Company <FontAwesomeIcon icon={faChevronDown} /></p>
              <ul className="dropdowng">
        <li className='iamredy'><Link to="/aboutus">About Us</Link></li>
        <li className='iamredy'><Link to="/whytravel">Why Travel With Us</Link></li>
        <li className='iamredy'><Link to="/meetourfounder">Meet Our Team</Link></li>
        <li className='iamredy'><Link to="/legal">Legal Documents</Link></li>
        <li className='iamredy'> <Link to="/reviews">Reviews</Link></li>
        <li className='iamredy'><Link to="/b2b">We Work For You (B2B)</Link></li>
      </ul>
          </li>
          <li className='a resources'>
              <FontAwesomeIcon icon={faImage} />
              <p className='p-nav'>Resources <FontAwesomeIcon icon={faChevronDown} /></p>
              <ul className="dropdown">
        <li className='iamredy'><Link to="/gallery">Gallery</Link></li>
        <li className='iamredy'><Link to="/Terms">Terms & Condition</Link></li>
        <li className='iamredy'><Link to="/faqs">FAQs</Link></li>
      </ul>
          </li>
        </ul>
      </nav>
    </header>
  )
}

export default NewNavbar